// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--dd-hea-box-cont-stlr{
    width: 100%;
    height: 100%;
    padding-left: var(--global-mobile-padding-left);
    padding-right: var(--global-mobile-padding-right);
    background-color: rgba(0, 0, 0, 1);
}

.scl--dd-hea-box-cont-stlr ul{
    list-style: none;
    padding: 0px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 11px;
}

.scl--dd-hea-box-cont-stlr ul li{
    width: 100%;
    height: 47px;
    border-bottom: 1px solid #191919;
    padding-top: 3px;
}

.scl--dd-hea-box-cont-stlr ul li button{
    border: none;
    outline: none;
    display: flex;
    justify-content: start;
    font-size: var(--font-size-body-sm);
    font-family: var(--primary-font);
    background-color: transparent;
    color: #fff;
    font-weight: lighter;
    width: 100%;
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/layout-module/layout-configuration/header/css/headerDropDown.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,iDAAiD;IACjD,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mCAAmC;IACnC,gCAAgC;IAChC,6BAA6B;IAC7B,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB","sourcesContent":[".scl--dd-hea-box-cont-stlr{\n    width: 100%;\n    height: 100%;\n    padding-left: var(--global-mobile-padding-left);\n    padding-right: var(--global-mobile-padding-right);\n    background-color: rgba(0, 0, 0, 1);\n}\n\n.scl--dd-hea-box-cont-stlr ul{\n    list-style: none;\n    padding: 0px;\n    margin-top: 30px;\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n}\n\n.scl--dd-hea-box-cont-stlr ul li{\n    width: 100%;\n    height: 47px;\n    border-bottom: 1px solid #191919;\n    padding-top: 3px;\n}\n\n.scl--dd-hea-box-cont-stlr ul li button{\n    border: none;\n    outline: none;\n    display: flex;\n    justify-content: start;\n    font-size: var(--font-size-body-sm);\n    font-family: var(--primary-font);\n    background-color: transparent;\n    color: #fff;\n    font-weight: lighter;\n    width: 100%;\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
